/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Spinner,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import moment from "moment-timezone";
import { useState } from "react";
import { IoReloadCircle } from "react-icons/io5";
import { toast } from "react-toastify";
import apiClient from "../../../utils/ApiClient/apiClientAxios";
import CustomModal from "../../Common/CustomModal/CustomModal";
import OrchestrationStatusCard from "./OrchestrationStatusCard";

const CaseProHistory = ({
  setHistory,
  history,
  setValue,
  setQuery,
  loading,
  fetchHistory,
}) => {
  const [activeId, setActiveId] = useState(null);
  const [viewData, setViewData] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleView = async (id, itemInfo) => {
    setViewData(itemInfo);
    onOpen();
  };

  const handleDelete = async (id) => {
    try {
      setActiveId(id);
      const res = await apiClient.delete(`/caseProcessor?id=${id}`);
      toast.success("Run has been terminated and removed from history.");
      setHistory((prev) => prev.filter((h) => h.id !== id));
    } catch (err) {
      toast.error("Unable to delete run.");
    } finally {
      setActiveId(null);
    }
  };

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={2}>
        <Text fontWeight="semibold">
          Case Processing History({history?.length})
        </Text>
        <IoReloadCircle
          onClick={fetchHistory}
          cursor="pointer"
          size="30px"
          title="Refresh history"
        />
      </Flex>
      <Box
        bg="gray.50"
        p={2}
        boxShadow="md"
        borderRadius="md"
        maxH="65vh"
        overflowY="auto"
      >
        {loading ? (
          <Flex align="center" justify="center" py={8}>
            <Spinner size="md" />
          </Flex>
        ) : history?.length === 0 ? (
          <Text color="gray.500" fontSize="sm" textAlign="center" py={4}>
            No history found.
          </Text>
        ) : (
          <VStack align="stretch" spacing={1}>
            {history?.map((item) => (
              <HistoryItem
                key={item.id}
                title={item.name || `Run ID: ${item.id}`}
                info={
                  moment.unix(item.created_at).format("YYYY-MM-DD HH:mm:ss") ||
                  "No date"
                }
                onView={() => handleView(item.id, item)}
                onDelete={() => handleDelete(item.id)}
                isLoading={activeId === item.id}
              />
            ))}
          </VStack>
        )}
      </Box>

      <CustomModal
        size="4xl"
        isCentered
        title="Case Process History"
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={<OrchestrationStatusCard data={viewData} />}
        footerContent={
          <Flex alignItems="center" gap={2}>
            <Button
              variant="primary"
              w="200px"
              mt={5}
              onClick={() => {
                if (viewData?.query) setQuery(viewData.query);
                if (viewData?.rules) setValue("rules", viewData.rules);
                if (viewData?.name) setValue("name", viewData?.name ?? "");
                onClose();
              }}
            >
              Copy Run
            </Button>
          </Flex>
        }
      />
    </Box>
  );
};

export default CaseProHistory;

const HistoryItem = ({ title, info, onView, onDelete, isLoading = false }) => {
  return (
    <Box
      p={3}
      borderRadius="md"
      bg="#E3F2FD"
      borderWidth="1px"
      borderColor="gray.200"
      boxShadow="sm"
      transition="all 0.2s ease-in-out"
      _hover={{
        transform: "translateY(-2px)",
        boxShadow: "md",
      }}
      cursor="pointer"
      my={2}
      onClick={(e) => {
        e.stopPropagation();
        onView();
      }}
    >
      <Flex align="center" justify="space-between" flexWrap="wrap">
        <Box>
          <Text
            fontWeight="semibold"
            fontSize="md"
            color="gray.800"
            flexWrap="wrap"
            overflow="hidden"
          >
            {title}
          </Text>
          <Text fontSize="sm" color="gray.600">
            {info}
          </Text>
        </Box>

        <Flex align="center" gap={2}>
          {isLoading ? (
            <Spinner size="sm" />
          ) : (
            <>
              {/* <ViewIcon
                onClick={onView}
                color="teal"
                cursor="pointer"
                title="View status"
              /> */}
              <DeleteIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                color="red"
                cursor="pointer"
                title="Delete run"
              />
            </>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};
